var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.missingImg,"alt":_vm.alt}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593a8e7e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ixcms/themes/src/vue-src/base/_base-missing-image.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-593a8e7e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ixcms/themes/src/vue-src/base/_base-missing-image.vue
// module chunks = 24